(() => {
  const galleries = document.querySelectorAll("media-gallery");
  if (!galleries.length) return;

  const buildVariantMap = (data) => {
    const map = new Map();
    data.forEach((component) => {
      const productId = String(component.productId);
      const variants = new Map();
      (component.variants || []).forEach((variant) => {
        if (variant && variant.id && variant.image) {
          variants.set(String(variant.id), variant.image);
        }
      });
      if (variants.size) {
        map.set(productId, variants);
      }
    });
    return map;
  };

  const buildOptionMaps = (data) => {
    const optionComponents = [];
    data.forEach((component) => {
      if (!component || !component.productId || !Array.isArray(component.options))
        return;
      const options = new Map();
      component.options.forEach((opt) => {
        if (opt && opt.value && opt.image) {
          options.set(String(opt.value), opt.image);
        }
      });
      if (!options.size) return;
      optionComponents.push({
        productId: String(component.productId),
        index: Number(component.index || 0),
        options,
      });
    });
    return optionComponents;
  };

  const updateImages = (gallery, productId, variantId, imageUrl) => {
    const slides = gallery.querySelectorAll(
      `.f-product__media[data-bundle-product-id="${productId}"]`
    );
    slides.forEach((slide) => {
      const img = slide.querySelector("img");
      if (!img) return;
      img.src = imageUrl;
      img.srcset = imageUrl;
      slide.dataset.bundleVariantId = String(variantId);
      slide.dataset.src = imageUrl;
      slide.setAttribute("data-src", imageUrl);

      const updateLightbox = (width, height) => {
        const mediaIndex = slide.dataset.mediaIndex;
        if (!mediaIndex) return;
        const lightbox = gallery.lightbox;
        const dataSource = lightbox && lightbox.options && lightbox.options.dataSource;
        if (!dataSource) return;
        const item = dataSource.find(
          (entry) => String(entry.id) === String(mediaIndex)
        );
        if (!item) return;
        item.src = imageUrl;
        item.width = width;
        item.height = height;
      };

      const probe = new Image();
      probe.onload = () => {
        const w = probe.naturalWidth || probe.width || 0;
        const h = probe.naturalHeight || probe.height || 0;
        slide.dataset.pswpWidth = String(w);
        slide.dataset.pswpHeight = String(h);
        slide.setAttribute("data-pswp-width", slide.dataset.pswpWidth);
        slide.setAttribute("data-pswp-height", slide.dataset.pswpHeight);
        updateLightbox(w, h);
      };
      probe.src = imageUrl;
    });

    const thumbs = gallery.querySelectorAll(
      `.f-product__media-thumbnails-item[data-bundle-product-id="${productId}"] img`
    );
    thumbs.forEach((img) => {
      img.src = imageUrl;
      img.srcset = imageUrl;
    });
  };

  galleries.forEach((gallery) => {
    const dataScript = gallery.querySelector("[data-bundle-components]");
    if (!dataScript) return;

    let data = [];
    try {
      data = JSON.parse(dataScript.textContent || "[]");
    } catch (e) {
      data = [];
    }

    const variantMap = buildVariantMap(data);
    const optionComponents = buildOptionMaps(data);
    if (!variantMap.size && !optionComponents.length) return;

    const handler = (event) => {
      const target = event.target;
      if (!target) return;

      let productId = target.dataset.productId;
      if (!productId) {
        const container = target.closest("[data-product-id]");
        productId = container && container.dataset.productId;
      }

      let variantId = target.value;
      if (!variantId) {
        variantId = target.dataset.variantId || target.dataset.variant;
      }

      if (!productId || !variantId) return;

      const variants = variantMap.get(String(productId));
      if (!variants) return;

      const imageUrl = variants.get(String(variantId));
      if (!imageUrl) return;

      updateImages(gallery, String(productId), String(variantId), imageUrl);
    };

    if (variantMap.size) {
      document.addEventListener("change", handler);
    }

    /* IS BUNDLE CUSTOM MODIFICHE */
    const applyCheckedBundleInputs = () => {
      const scope = gallery.closest("product-info") || document;
      const checked = scope.querySelectorAll(
        "[data-bundle-component-input]:checked, [data-bundle-component-select]"
      );
      checked.forEach((input) => {
        const productId = input.dataset.productId;
        const variantId = input.value || input.dataset.variantId;
        if (input.tagName === "SELECT") {
          const selectedOption = input.selectedOptions[0];
          if (!selectedOption || selectedOption.disabled) return;
        }
        if (!productId || !variantId) return;
        const variants = variantMap.get(String(productId));
        if (!variants) return;
        const imageUrl = variants.get(String(variantId));
        if (!imageUrl) return;
        updateImages(gallery, String(productId), String(variantId), imageUrl);
      });
    };

    const applyOptionImages = (variant) => {
      if (!variant || !optionComponents.length) return;
      const optionValues =
        variant.options ||
        [variant.option1, variant.option2, variant.option3].filter(Boolean);
      if (!optionValues || !optionValues.length) return;

      optionComponents.forEach((component) => {
        const optionValue = optionValues[component.index];
        if (!optionValue) return;
        const imageUrl = component.options.get(String(optionValue));
        if (!imageUrl) return;
        updateImages(gallery, component.productId, optionValue, imageUrl);
      });

      // After updating, move the slider to the bundle image that changed.
      const bundleSlides = Array.from(
        gallery.querySelectorAll(".f-product__media[data-bundle-product-id]")
      );
      if (!bundleSlides.length || typeof gallery.setActiveMedia !== "function") {
        gallery.dataset.bundleLastOptions = JSON.stringify(optionValues);
        return;
      }

      let targetIndex = 0;
      try {
        const prev = JSON.parse(gallery.dataset.bundleLastOptions || "[]");
        if (Array.isArray(prev) && prev.length) {
          const changedIndex = optionValues.findIndex(
            (value, idx) => value !== prev[idx]
          );
          if (changedIndex >= 0) targetIndex = changedIndex;
        }
      } catch (e) {
        // noop
      }

      const targetSlide = bundleSlides[targetIndex] || bundleSlides[0];
      const mediaId = targetSlide && targetSlide.dataset.mediaId;
      if (mediaId) {
        gallery.setActiveMedia(Number(mediaId));
      }
      gallery.dataset.bundleLastOptions = JSON.stringify(optionValues);
    };

    const productInfo = gallery.closest("product-info");
    const productDataScript =
      productInfo && productInfo.querySelector("#ProductData");
    if (productDataScript) {
      try {
        const productData = JSON.parse(productDataScript.textContent || "{}");
        const currentVariantId =
          productInfo &&
          productInfo.querySelector('input[name="id"]')?.value;
        const currentVariant =
          (currentVariantId &&
            productData.variants &&
            productData.variants.find(
              (variant) => variant.id === Number(currentVariantId)
            )) ||
          productData.selected_or_first_available_variant ||
          (productData.variants && productData.variants[0]);
        applyOptionImages(currentVariant);
      } catch (e) {
        // noop
      }
    }

    /* IS BUNDLE CUSTOM MODIFICHE */
    if (variantMap.size) {
      applyCheckedBundleInputs();
      setTimeout(applyCheckedBundleInputs, 0);
    }

    document.addEventListener("variant:changed", (event) => {
      const detail = event.detail || {};
      const sectionId = detail.sectionId;
      if (sectionId && gallery.dataset.sectionId !== String(sectionId)) return;
      applyOptionImages(detail.variant);
    });
  });
})();
